import { TListingClient } from 'types/TListing';
import fetchAPI from '../utils/fetchAPI';
import formatQueryString from '../utils/formatQueryString';

type TGetDealerHighlightsParams = {
  adId: TListingClient['itemId'];
};

export default async function getDealerHighlights(params: TGetDealerHighlightsParams) {
  try {
    return await fetchAPI({
      url: `/v/api/dealer-highlights?${formatQueryString(params)}`,
    });
  } catch {
    return null;
  }
}
